import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

const jumpAnimation = keyframes`
  0% {
    transform: translateY(0);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  50% {
    transform: translateY(-15px);
    box-shadow: 0 8px 12px rgba(0, 0, 0, 0.2);
  }
  100% {
    transform: translateY(0);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
`;

const shakeAnimation = keyframes`
  0% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-5px);
  }
  50% {
    transform: translateX(5px);
  }
  75% {
    transform: translateX(-5px);
  }
  100% {
    transform: translateX(0);
  }
`;

export const BtnCallMe = styled.button`
    position: fixed;
    bottom: 80px;
    right: 20px;
    padding: 16px 20px;
    font-size: 16px;
    font-weight: bold;
    text-transform: uppercase;
    border: none;
    border-radius: 50%;
    background-color: var(--brand-orange);
    border: 3px solid #d5d5d5;
    color: #fff;
    cursor: pointer;
    transition: background-color 0.3s ease;
    animation: ${jumpAnimation} 3s infinite;
`;

export const ShakeIcon = styled.div`
    display: inline-block;
    animation: ${shakeAnimation} 0.6s infinite;
`;

export const TextereaBoxCallMe = styled.textarea`
    height: 80px;
    width: 240px;
    margin-bottom: 12px;
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42;
    letter-spacing: 0.21px;
    color: var(--brand-gray);
    resize: none;
    border-radius: 3px;
    border: 1px solid rgba(0, 0, 0, 0.3);
    padding: 10px 16px;

    @media (min-width: 688px){
        width: 300px;
    }

    @media (min-width: 780px){
        width: 512px;
        height: 80px;
    }
`;
